import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d1c8e38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-gordita-regular" }
const _hoisted_3 = { class: "font-gordita-medium" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediTooltip } from 'incredi-ui';
import { ref } from 'vue';
import moment from 'moment';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'legend-row',
  props: {
    legend: { type: Boolean, default: true },
    textColor: null,
    color: null,
    text: null,
    tooltipInfo: { default: null },
    hideLegend: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { legend: boolean, textColor: string, color: string, text: string, tooltipInfo: { displayTooltip: boolean | null; cooldownNextRelease: number | null } | null, hideLegend: boolean }

const showTooltip = ref(false);


const { t } = useI18n();
const getCoolDownNextReleaseTime = () => {
  const currentDate = new Date();
  const diff = Number(props?.tooltipInfo?.cooldownNextRelease) - Number(currentDate);
  return moment.duration(diff);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "circle",
          style: _normalizeStyle({ backgroundColor: __props.color, visibility: __props.legend ? 'visible' : 'hidden', opacity: __props.hideLegend ? 0 : 1 })
        }, null, 4),
        _createElementVNode("div", {
          style: _normalizeStyle({ color: __props.textColor || 'unset' }),
          class: "title text-brand_almost_black"
        }, _toDisplayString(__props.text), 5),
        (__props.tooltipInfo?.displayTooltip)
          ? (_openBlock(), _createBlock(_unref(IncrediTooltip), {
              key: 0,
              modelValue: showTooltip.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showTooltip).value = $event)),
              hover: "",
              direction: "bottom-middle",
              "offset-x": 35,
              style: {"border-radius":"2px"},
              delay: 200
            }, {
              content: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(`${_unref(t)('dashboard.top.topRightBars.coolDownTooltip')} `), 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(moment).utc(getCoolDownNextReleaseTime().hours() * 3600 * 1000).format('HH')) + ":" + _toDisplayString(_unref(moment).utc(getCoolDownNextReleaseTime().minutes() * 60 * 1000).format('mm')), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("i", {
                    class: _normalizeClass([showTooltip.value ? 'uis uis-info-circle' : 'uil uil-info-circle', "text-[12px] text-Text/text_medium ml-[3px]"])
                  }, null, 2)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})